import { NavigationGuard } from 'vue-router';
import { getInstance } from './authPlugin';
import { checkScope } from '@/auth/checkToken';
import { BLOCKBUSTER_SCOPES, SURELOCK_SCOPES } from '@/utils/constants';
import * as _ from 'lodash';

export const authGuard: NavigationGuard = (to, from, next) => {
  const authService = getInstance();

  const unwatch = authService.$watch('loading', loading => {
    if (!loading) {
      return guardRoute();
    }
  });

  const guardRoute = () => {
    // This is Vue's way to stop firing the callback
    // https://vuejs.org/v2/api/#vm-watch
    unwatch && unwatch();

    if (authService.isAuthenticated) {
      return next();
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return guardRoute();
  }
}

export const blockbusterGuard: NavigationGuard = async (to, from, next) => {
  const authService = getInstance();

  const unwatch = authService.$watch('loading', loading => {
    if (!loading) {
      return guardRoute();
    }
  });

  const guardRoute = async () => {
    // This is Vue's way to stop firing the callback
    // https://vuejs.org/v2/api/#vm-watch
    unwatch && unwatch();

    if (authService.isAuthenticated) {
      const token = await authService.getTokenSilently({ audience: 'https://blockbuster.cam.simplisafe.com/' });

      if (checkScope(token, BLOCKBUSTER_SCOPES.READ_METADATA)) {
        return next();
      }

      // go back to homepage
      return next(Error('Unauthorized - No Blockbuster Access!'));
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return guardRoute();
  }
}

export const surelockGuard: NavigationGuard = async (to, from, next) => {
  const authService = getInstance();

  const unwatch = authService.$watch('loading', loading => {
    if (!loading) {
      return guardRoute();
    }
  });

  const guardRoute = async () => {
    // This is Vue's way to stop firing the callback
    // https://vuejs.org/v2/api/#vm-watch
    unwatch && unwatch();

    if (authService.isAuthenticated) {
      const token = await authService.getTokenSilently({ audience: 'https://surelock.cam.simplisafe.com/' });

      if (checkScope(token, SURELOCK_SCOPES.READ_PRESERVATION)) {
        return next();
      }

      // return to homepage
      return next(Error('Unauthorized - No SureLock Access!'));
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return guardRoute();
  }
}

export const surelockCreateGuard: NavigationGuard = async (to, from, next) => {
  const authService = getInstance();

  const unwatch = authService.$watch('loading', loading => {
    if (!loading) {
      return guardRoute();
    }
  });

  const guardRoute = async () => {
    // This is Vue's way to stop firing the callback
    // https://vuejs.org/v2/api/#vm-watch
    unwatch && unwatch();

    if (authService.isAuthenticated) {
      const token = await authService.getTokenSilently({ audience: 'https://surelock.cam.simplisafe.com/' });

      if (checkScope(token, SURELOCK_SCOPES.CREATE_PRESERVATION)) {
        return next();
      }

      // return to homepage
      return next(Error('Unauthorized - No SureLock Initiator Access!'));
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return guardRoute();
  }
}
